<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content" v-if="show && showData">
        <div class="modal-header">
          <span v-html="selectedBlock?.type?.icon" class="me-2"></span>
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ selectedBlock?.type?.name }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            v-on:click="$emit('update:show', false)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body px-5">
          <div
            v-for="section in elements.filter((e) => e.type !== 'array')"
            :key="section"
          >
            <h3>{{ section?.name }}</h3>
            <div class="mb-4" v-if="section.type == 'featured-products'">
              <div class="col-12">
                <div class="text-center">
                  <div class="py-4">
                    <div class="row g-3 justify-content-center">
                      <!-- Product -->
                      <div class="col-6 col-md-3">
                        <button
                          class="w-100 option-card btn p-3"
                          :class="{ active: productSelector === 'product' }"
                          @click="productSelector = 'product'"
                        >
                          <div class="option-icon mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="icon icon-tabler icons-tabler-outline icon-tabler-list-search"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path
                                d="M15 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
                              />
                              <path d="M18.5 18.5l2.5 2.5" />
                              <path d="M4 6h16" />
                              <path d="M4 12h4" />
                              <path d="M4 18h4" />
                            </svg>
                          </div>
                          <div class="fw-bold">Products</div>
                          <small class="text-muted">Select products</small>
                        </button>
                      </div>
                      <!-- Bundles -->
                      <div class="col-6 col-md-3">
                        <button
                          class="w-100 option-card btn p-3"
                          :class="{ active: productSelector === 'bundle' }"
                          @click="productSelector = 'bundle'"
                        >
                          <div class="option-icon mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="icon icon-tabler icons-tabler-outline icon-tabler-devices-search"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path
                                d="M13 13v-4a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2.5"
                              />
                              <path
                                d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7"
                              />
                              <path
                                d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
                              />
                              <path d="M20.2 20.2l1.8 1.8" />
                              <path d="M16 9h2" />
                            </svg>
                          </div>
                          <div class="fw-bold">Bundles</div>
                          <small class="text-muted">Select bundles</small>
                        </button>
                      </div>
                      <!-- Filters -->
                      <div class="col-6 col-md-3">
                        <button
                          class="w-100 option-card btn p-3"
                          :class="{ active: productSelector === 'filter' }"
                          @click="productSelector = 'filter'"
                        >
                          <div class="option-icon mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="icon icon-tabler icons-tabler-outline icon-tabler-filter-search"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path
                                d="M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414"
                              />
                              <path
                                d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
                              />
                              <path d="M20.2 20.2l1.8 1.8" />
                            </svg>
                          </div>
                          <div class="fw-bold">Filters</div>
                          <small class="text-muted"
                            >Use rules to auto-select</small
                          >
                        </button>
                      </div>
                      <div class="col-6 col-md-3" v-if="dynamic?.length > 0">
                        <button
                            class="w-100 option-card btn p-3"
                            :class="{ active: productSelector === 'dynamic' }"
                            @click="productSelector = 'dynamic'"
                        >
                          <div class="option-icon mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11" /></svg>
                          </div>
                          <div class="fw-bold">Dynamic</div>
                          <small class="text-muted"
                          >Dynamic product list</small
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    productSelector === 'product' ||
                    productSelector === 'bundle'
                  "
                >
                  <div
                    class="row custom-input whitebg-input"
                    v-for="p in productList"
                    :key="p.id"
                  >
                    <div>
                      <div class="mb-3">
                        <label class="form-label bold-12 text-gray"
                          >Product</label
                        >
                        <v-select
                          v-model:options="p.products"
                          v-on:search="(s, k) => fetchProducts(s, k, p)"
                          v-model="p.id"
                          :filterable="false"
                          placeholder="Search for products"
                          :reduce="(c) => c.variant_id"
                          :getOptionKey="(c) => c.variant_id"
                          v-on:option:selected="
                            (e) => changeProducts(e.variant_id)
                          "
                          v-on:option:deselected="() => changeProducts(0)"
                        >
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching && search.length > 2">
                              No result for
                              <em>{{ search }}</em
                              >.
                            </template>
                            <span v-else>No result</span>
                          </template>
                          <template v-slot:selected-option="option">
                            <div class="row">
                              <div class="col-auto px-0">
                                <img
                                  :src="option?.image"
                                  v-if="
                                    option?.image !== null &&
                                    option?.image !== undefined
                                  "
                                  class="product-image"
                                  alt=""
                                />
                                <BaseIcon
                                  v-else
                                  name="no-image"
                                  class="product-image"
                                />
                              </div>
                              <div class="col">
                                <div>
                                  <b>{{ option.name }}</b>
                                </div>
                                <div>
                                  <span
                                    v-for="char in option.caracteristics"
                                    :key="char"
                                    class="me-2"
                                  >
                                    {{ char }}
                                  </span>
                                  <span class="me-2">
                                    {{ option.serial }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-slot:option="option">
                            <span class="me-2">
                              {{ option.serial }}
                            </span>
                            <span
                              v-for="char in option.caracteristics"
                              :key="char"
                              class="me-2"
                            >
                              {{ char }}
                            </span>
                            <b>{{ option.name }}</b>
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3" v-if="productSelector === 'dynamic'">
                  <div class="row">
                    <div class="col-12">
                      <label>Product list</label>
                      <v-select
                          v-model="settingsData.dynamic_block"
                          :options="dynamic"
                          placeholder="Select variable"
                      />
                    </div>
                  </div>
                </div>
                <div class="mt-3" v-if="productSelector === 'filter'">
                  <div class="row">
                    <div class="col-8">
                      <label>Product categories</label>
                      <template v-if="section.categories === null || section.categories === undefined || section.categories === 1">
                        <v-select
                          v-if="editorMode['category'] === 'select'"
                          v-model="settingsData.featured_category"
                          v-model:options="categories"
                          label="name"
                          :filter="
                            (s, q) =>
                              s.filter(
                                (e) => e.name.toLowerCase().indexOf(q) > -1
                              )
                          "
                          multiple
                          placeholder="Select category"
                          :reduce="(c) => c.featured_category"
                        />
                        <v-select
                            v-else-if="editorMode['category'] === 'variables'"
                            v-model="settingsData.var_featured_category"
                            :options="variables"
                            placeholder="Select variable"
                        />
                      </template>
                      <template v-else>
                        <div v-for="i in Array.from({ length: section.categories }, (_, i) => i)" :key="i">
                          <v-select
                              v-if="editorMode['category'] === 'select'"
                              v-model="settingsData.featured_category[i]"
                              v-model:options="categories"
                              label="name"
                              :filter="
                            (s, q) =>
                              s.filter(
                                (e) => e.name.toLowerCase().indexOf(q) > -1
                              )
                          "
                              multiple
                              placeholder="Select category"
                              :reduce="(c) => c.featured_category"
                          />
                          <v-select
                              v-else-if="editorMode['category'] === 'variables'"
                              v-model="settingsData.var_featured_category[i]"
                              :options="variables"
                              placeholder="Select variable"
                          />
                        </div>
                      </template>
                      <div class="row" v-if="variables?.length > 0">
                        <div class="col"></div>
                        <div class="col-auto">
                          <fieldset
                              class="segmented-control"
                              role="radiogroup"
                              aria-label="Mode"
                          >
                            <input
                                type="radio"
                                name="mode_category"
                                id="mode_val_category"
                                value="select"
                                v-model="editorMode['category']"
                            />
                            <label for="mode_val_category">
                              Select values
                            </label>
                            <input
                                type="radio"
                                name="mode_category"
                                id="mode_vars_category"
                                value="variables"
                                v-model="editorMode['category']"
                            />
                            <label for="mode_vars_category">
                              Use variables
                            </label>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <label>Product limit</label>
                      <input
                        class="form-control"
                        type="number"
                        v-model="settingsData.limit"
                        placeholder="30"
                      />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-12">
                      <label>Product discount</label>
                      <RangeSlider
                        v-model:range="settingsData.discount"
                        :min="0"
                        :max="100"
                        :step="1"
                        :format="(v) => `${v}%`"
                      />
                    </div>
                  </div>
                  <div class="mt-4 row">
                    <div class="p-3 col-6 border roundedm">
                      <div class="row mb-2">
                        <div class="col-8">
                          <h5 class="mb-0 d-inline-block">Tags</h5>
                          <small
                            v-if="(settingsData.tags || []).length"
                            class="text-primary"
                          >
                            ({{ (settingsData.tags || []).length }} selected
                            <button
                              class="btn btn-sm btn-light ms-1"
                              @click="settingsData.tags = []"
                              title="Remove all"
                            >
                              Remove all</button
                            >)
                          </small>
                        </div>
                        <div class="col-4">
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="searchTerms.tags"
                              placeholder="Search..."
                              aria-label="Search tags"
                            />
                            <button
                              v-if="searchTerms.tags"
                              class="btn btn-outline-secondary btn-sm"
                              type="button"
                              @click="searchTerms.tags = ''"
                              aria-label="Clear"
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="row g-1 filters">
                        <div
                          v-for="tag in sortedAndFilteredTags"
                          :key="tag.id"
                          class="col-12"
                        >
                          <div
                            :class="[
                              'form-check p-1 ms-4 rounded border position-relative',
                              isTagSelected(tag.id)
                                ? 'bg-light border-primary'
                                : 'bg-white',
                              'hover-shadow',
                            ]"
                          >
                            <label
                              class="form-check-label d-flex align-items-center w-100 mb-0"
                              :for="`tag-${tag.id}`"
                            >
                              <input
                                class="form-check-input me-2"
                                type="checkbox"
                                :id="`tag-${tag.id}`"
                                :value="tag.id"
                                v-model="settingsData.tags"
                              />
                              <div class="flex-grow-1">
                                <div
                                  v-html="
                                    highlightMatch(tag.name, searchTerms.tags)
                                  "
                                ></div>
                              </div>
                              <span
                                v-if="isTagSelected(tag.id)"
                                class="badge bg-primary ms-2"
                                >Selected</span
                              >
                            </label>
                          </div>
                        </div>
                        <div
                          v-if="sortedAndFilteredTags.length === 0"
                          class="col-12"
                        >
                          <small class="text-muted">No result.</small>
                        </div>
                      </div>
                    </div>
                    <div
                      v-for="ch in characteristics.filter(
                        (e) => e.characteristics_values?.length > 0
                      )"
                      :key="ch.id"
                      class="p-3 col-6 border rounded"
                    >
                      <div class="row">
                        <div class="col-8">
                          <h5 class="mb-0 d-inline-block">
                            {{ ch.name }}
                          </h5>
                          <small
                            v-if="
                              (settingsData.characteristics[ch.id] || []).length
                            "
                            v-show="editorMode[ch.id] === 'select'"
                            class="text-primary"
                          >
                            ({{
                              (settingsData.characteristics[ch.id] || []).length
                            }}
                            selected
                            <button
                              v-if="
                                (settingsData.characteristics[ch.id] || [])
                                  .length
                              "
                              class="btn btn-sm btn-light"
                              @click="settingsData.characteristics[ch.id] = []"
                              title="Remove all"
                            >
                              Remove all</button
                            >)
                          </small>
                        </div>
                        <div
                          class="col-4"
                          v-show="editorMode[ch.id] === 'select'"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="searchTerms[ch.id]"
                              :placeholder="`Search...`"
                              aria-label="Keresés a jellemzők között"
                            />
                            <button
                              v-if="searchTerms[ch.id]"
                              class="btn btn-outline-secondary btn-sm"
                              type="button"
                              @click="searchTerms[ch.id] = ''"
                              aria-label="Remove"
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="row g-1 filters"
                        v-show="editorMode[ch.id] === 'select'"
                      >
                        <div
                          v-for="val in sortedAndFilteredValues(ch)"
                          :key="val.id"
                          class="col-12"
                        >
                          <div
                            :class="[
                              'form-check pb-1 ms-3 rounded border position-relative',
                              isSelected(ch.id, val.id)
                                ? 'bg-light border-primary'
                                : 'bg-white',
                              'hover-shadow',
                            ]"
                          >
                            <label
                              class="form-check-label d-flex align-items-center w-100 mb-0"
                              :for="`chk-${ch.id}-${val.id}`"
                            >
                              <input
                                class="form-check-input me-2"
                                type="checkbox"
                                :id="`chk-${ch.id}-${val.id}`"
                                :value="val.id"
                                v-model="settingsData.characteristics[ch.id]"
                              />
                              <div class="flex-grow-1">
                                <div
                                  v-html="
                                    highlightMatch(
                                      val.value,
                                      searchTerms[ch.id]
                                    )
                                  "
                                ></div>
                              </div>
                              <span
                                v-if="isSelected(ch.id, val.id)"
                                class="badge bg-primary ms-2"
                              >
                                Selected
                              </span>
                            </label>
                          </div>
                        </div>
                        <div
                          v-if="sortedAndFilteredValues(ch).length === 0"
                          class="col-12"
                        >
                          <small class="text-muted">No result.</small>
                        </div>
                      </div>
                      <div class="row" v-if="editorMode[ch.id] === 'variables'">
                        <v-select
                            v-model="settingsData.var_characteristics[ch.id]"
                            :options="variables"
                            placeholder="Select variable"
                        />
                      </div>
                      <div class="row" v-if="variables?.length > 0">
                        <div class="col"></div>
                        <div class="col-auto">
                          <fieldset
                            class="segmented-control"
                            role="radiogroup"
                            aria-label="Mode"
                          >
                            <input
                              type="radio"
                              :name="'mode_' + ch.id"
                              :id="'mode_val_' + ch.id"
                              value="select"
                              v-model="editorMode[ch.id]"
                            />
                            <label :for="'mode_val_' + ch.id">
                              Select values
                            </label>
                            <input
                              type="radio"
                              :name="'mode_' + ch.id"
                              :id="'mode_vars_' + ch.id"
                              value="variables"
                              v-model="editorMode[ch.id]"
                            />
                            <label :for="'mode_vars_' + ch.id">
                              Use variables
                            </label>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mb-4"
              v-else-if="section.type === 'rich-text' && !refresh"
            >
              <div
                :ref="'edit-text-' + section.key"
                v-html="
                  section.translate
                    ? typeof settingsData[section.key] === 'object'
                      ? settingsData[section.key][language]
                      : ''
                    : settingsData[section.key]
                "
              ></div>
            </div>
            <div class="mb-4" v-else-if="section.type === 'long-text'">
              <textarea
                type="text"
                class="form-control"
                v-model="settingsData[section.key]"
              ></textarea>
            </div>
            <div class="mb-4" v-else-if="section.type === 'html'">
              <CodeMirror v-model="settingsData[section.key]" />
            </div>
            <div class="mb-4" v-else-if="section.type === 'variable'">
              <label>Product list</label>
              <v-select
                  v-model="settingsData[section.key].val"
                  :options="dynamic"
                  placeholder="Select variable"
              />
            </div>
            <div class="mb-4 col-12 row" v-else-if="section.type === 'image'">
              <div class="col-12">
                <input
                  type="file"
                  :ref="'file_' + btoa(section.key)"
                  :id="'file_' + btoa(section.key)"
                  v-on:change="upload(section.key, section?.image ?? 'cover')"
                  style="display: none"
                />
                <div class="block-list c-4">
                  <div class="selected-image-block">
                    <img
                      v-if="
                        settingsData[section.key] !== undefined &&
                        settingsData[section.key] !== null
                      "
                      alt=""
                      class=""
                      :src="
                        typeof settingsData[section.key] === 'string'
                          ? settingsData[section.key]
                          : settingsData[section.key]?.src
                      "
                    />
                  </div>
                  <div class="block">
                    <button
                      v-on:click="
                        fileEditType = 'upload';
                        startUpload(btoa(section.key));
                      "
                    >
                      <div class="block-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M12 12.5858L16.2426 16.8284L14.8284 18.2426L13 16.415V22H11V16.413L9.17157 18.2426L7.75736 16.8284L12 12.5858ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18.0009 16.9644C19.6966 16.7214 21 15.2629 21 13.5C21 11.567 19.433 10 17.5 10C17.2912 10 17.0867 10.0183 16.8887 10.054C16.9616 9.7142 17 9.36158 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.36158 7.03838 9.7142 7.11205 10.0533C6.91331 10.0183 6.70879 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.2003 4.21241 16.6174 5.81986 16.934L6.00005 16.9646L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
                          ></path>
                        </svg>
                      </div>
                      <div class="block-name">Upload</div>
                    </button>
                  </div>
                  <div class="block">
                    <button v-on:click="fileEditType = 'search'">
                      <div class="block-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"
                          ></path>
                        </svg>
                      </div>
                      <div class="block-name">Search</div>
                    </button>
                  </div>
                  <div class="block">
                    <button
                      v-on:click="
                        browseImages(section.key);
                        fileEditType = 'browse';
                      "
                    >
                      <div class="block-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M6 7V4C6 3.44772 6.44772 3 7 3H13.4142L15.4142 5H21C21.5523 5 22 5.44772 22 6V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6ZM6 9H4V19H16V17H6V9ZM8 5V15H20V7H14.5858L12.5858 5H8Z"
                          ></path>
                        </svg>
                      </div>
                      <div class="block-name">Browse</div>
                    </button>
                  </div>
                </div>
                <div v-if="fileEditType === 'search'">
                  <v-select
                    v-model="settingsData[section.key]"
                    v-model:options="images[section.key]"
                    v-on:search="(a, e) => fetchImages(a, e, section.key)"
                    :filterable="false"
                    :reduce="(c) => getImageLinks(c)"
                    placeholder="Select image"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching && search.length > 2">
                        No item found for <em>{{ search }}</em
                        >.
                      </template>
                      <span v-else> Start typing to search</span>
                    </template>
                    <template v-slot:selected-option="option">
                      <img :src="getImageLinks(option).src" width="80" alt="" />
                      <span>{{ option.name }}</span>
                    </template>
                    <template v-slot:option="option">
                      <img
                        :src="
                          mediaServer +
                          '/' +
                          option.path +
                          '/' +
                          option.name +
                          '.webp'
                          // option.format
                        "
                        width="80"
                        alt=""
                      />
                      <span>{{ option.name }}</span>
                    </template>
                  </v-select>
                </div>
                <div v-if="fileEditType === 'upload'">
                  <div v-if="uploadProccess" class="status-bar mt-1">
                    <span
                      class="status-bar-process"
                      :style="`width: ${uploadPercent}%`"
                    ></span>
                  </div>
                </div>
                <div v-if="fileEditType === 'browse'">
                  <div class="my-3">
                    <button
                      class="btn btn-outline-primary"
                      v-on:click="browseImages(section.key, 2)"
                    >
                      Category
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      v-on:click="browseImages(section.key, 3)"
                    >
                      Cover
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      v-on:click="browseImages(section.key, 4)"
                    >
                      Color
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      v-on:click="browseImages(section.key, 5)"
                    >
                      Icon
                    </button>
                  </div>
                  <div class="block-list browse-img">
                    <div v-for="img in images[section.key]" :key="img.id">
                      <button
                        class="delete-btn"
                        @click.stop="deleteImage(section.key, img.id)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M4 7l16 0" />
                          <path d="M10 11l0 6" />
                          <path d="M14 11l0 6" />
                          <path
                            d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
                          />
                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                        </svg>
                      </button>
                      <img
                        v-on:click="
                          settingsData[section.key] = getImageLinks(img)
                        "
                        loading="lazy"
                        :src="
                          mediaServer +
                          '/' +
                          img.path +
                          (img.type < 4 ? '/540-' : '/128-') +
                          img.name +
                          '.webp'
                          // option.format
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4 col-12 row" v-else-if="section.type === 'video'">
              <div class="col-sm-12">
                {{ settingsData[selectedVideo]?.name }}
                <button
                  class="btn btn-primary"
                  v-on:click="
                    selectedVideo = section.key;
                    showVideoModal = true;
                  "
                >
                  Select or upload video
                </button>
              </div>
            </div>
            <div class="mb-4 col-12 row" v-else-if="section.type === 'link'">
              <div class="col-sm-12">
                {{ settingsData[section.key] }}
                <v-select
                  v-model="settingsData[section.key]"
                  :options="filteredLinks"
                  :reduce="(c) => getLink(c)"
                  v-on:search="(s, k) => onLinkSearch(s, k)"
                  :filterable="false"
                  :getOptionKey="(c) => getLink(c)"
                  :create-option="(name) => ({ target_url: name, name: name })"
                  placeholder="Select one"
                  label="name"
                  clearable
                  taggable
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching && search.length > 2">
                      No item found for <em>{{ search }}</em
                      >.
                    </template>
                    <span v-else> Start typing to search</span>
                  </template>
                  <template v-slot:selected-option="option">
                    <span v-if="typeof option === 'string'">{{ option }}</span>
                    <span v-else>{{ option.name }}</span>
                    <span
                      class="badge bg-primary ms-2"
                      v-if="option.featured_category"
                    >
                      Category
                    </span>
                    <span
                      class="badge bg-yellow ms-2"
                      v-if="option.target_page_id"
                    >
                      Page
                    </span>
                    <span class="badge bg-green ms-2" v-if="option.variant_id">
                      Product
                    </span>
                  </template>
                  <template v-slot:option="option">
                    <span v-if="typeof option === 'string'">{{ option }}</span>
                    <span v-else>{{ option.name }}</span>
                    <span
                      class="badge bg-primary ms-2"
                      v-if="option.featured_category"
                    >
                      Category
                    </span>
                    <span
                      class="badge bg-yellow ms-2"
                      v-if="option.target_page_id"
                    >
                      Page
                    </span>
                    <span class="badge bg-green ms-2" v-if="option.variant_id">
                      Product
                    </span>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="mb-4" v-else-if="section.type === 'enum'">
              <div class="input-group">
                <select
                  :value="getValue(section)"
                  @change="setValue(section, $event.target.value)"
                >
                  <option v-for="(c, i) in section.values" :key="i" :value="i">
                    {{ c }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-4" v-else>
              <input
                type="text"
                :value="getValue(section)"
                @input="setValue(section, $event.target.value)"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer custom-input">
          <div class="row w-100">
            <div class="col-3">
              <div class="input-group" v-if="translatable">
                <label>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M18.5 10l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16.5 10h2zM10 2v2h6v2h-1.968a18.222 18.222 0 0 1-3.62 6.301 14.864 14.864 0 0 0 2.336 1.707l-.751 1.878A17.015 17.015 0 0 1 9 13.725a16.676 16.676 0 0 1-6.201 3.548l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042A18.078 18.078 0 0 1 4.767 8h2.24A16.032 16.032 0 0 0 9 10.877a16.165 16.165 0 0 0 2.91-4.876L2 6V4h6V2h2zm7.5 10.885L16.253 16h2.492L17.5 12.885z"
                    />
                  </svg>
                </label>
                <select class="form-control" v-model="language">
                  <option
                    v-for="lang in languages"
                    :key="lang.code"
                    :value="lang.code"
                  >
                    {{ lang.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col"></div>
            <div class="col-auto">
              <button class="btn btn-primary" v-on:click="save">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <VideoUpload
    v-model:show="showVideoModal"
    v-on:select="(video) => (settingsData[selectedVideo] = video)"
  />
</template>

<script>
import http from "../../modules/http";
import VideoUpload from "./VideoUpload";
import { useStore } from "vuex";
import CodeMirror from "../CodeMirror.vue";
import RangeSlider from "../RangeSlider.vue";
const bootstrap = require("bootstrap");

export default {
  name: "EditContent",
  components: { RangeSlider, CodeMirror, VideoUpload },
  props: {
    show: Boolean,
    block: Object,
    settings: Object,
    elements: Object,
    variables: Array,
    dynamic: Array,
    items: Object,
    values: Object,
    languages: Array,
    name: String,
    i: Number,
  },
  emits: [
    "update:show",
    "update:values",
    "addBlock",
    "update:block",
    "update:settings",
  ],
  data() {
    return {
      store: useStore(),
      searchTerms: {},
      editorMode: {
        category: "select",
      },
      selectedBlock: {},
      valuesData: {},
      settingsData: {},
      myModal: undefined,
      selectedVideo: null,
      quill: {},
      showData: false,
      language: undefined,
      links: [],
      fileEditType: "",
      productList: [{ id: null, products: [] }],
      q: "",
      productSelector: undefined,
      categories: [],
      characteristics: [],
      images: {},
      refresh: false,
      translatable: false,
      uploadPercent: 0,
      uploadProccess: false,
      showVideoModal: false,
      linkSearch: "",
      linkProducts: { products: [] },
    };
  },
  computed: {
    mediaServer() {
      return process.env.VUE_APP_MEDIA_URL;
    },
    tags() {
      return this.store.state.user.tags.products;
    },
    filteredLinks() {
      let search = this.linkSearch.trim().toLowerCase();

      if (!search) {
        return [...this.links, ...this.linkProducts.products];
      }
      return [
        ...this.links.filter((l) => l.name.toLowerCase().indexOf(search) > -1),
        ...this.linkProducts.products,
      ];
    },
    sortedAndFilteredTags() {
      const term = (this.searchTerms.tags || "")
        .toString()
        .toLowerCase()
        .trim();
      const selected = new Set(this.settingsData.tags || []);
      let values = (this.tags || []).filter((tag) => {
        if (!term) return true;
        return String(tag.name).toLowerCase().includes(term);
      });

      const selectedItems = values.filter((v) => selected.has(v.id));
      const unselected = values.filter((v) => !selected.has(v.id));
      return [...selectedItems, ...unselected];
    },
  },
  mounted() {
    this.myModal = new bootstrap.Modal(this.$refs.modal, {
      backdrop: "static",
    });
    if (this.show) {
      this.myModal.show();
    } else {
      this.myModal.hide();
    }
  },
  watch: {
    block() {
      this.selectedBlock = this.block;
    },
    settings() {
      //this.settingsData = this.settings;
      this.settingsData = Object.assign({}, this.settings);

      for (const section of this.elements) {
        if (section?.translate) {
          if (typeof this.settingsData[section.key] !== "object") {
            this.settingsData[section.key] = {};
          }
        }
        if(section.type === 'variable' && typeof this.settingsData[section.key] !== 'object') {
          this.settingsData[section.key] = {'type':'variable','val':''};
        }
      }
    },
    productSelector() {
      if (this.productSelector === "filter") {
        if (typeof this.settingsData.featured_category !== "object") {
          this.settingsData.featured_category = [];
        }
        if (typeof this.settingsData.tags !== "object") {
          this.settingsData.tags = [];
        }
        if (typeof this.settingsData.characteristics !== "object") {
          this.settingsData.characteristics = {};
        }
        if (typeof this.settingsData.var_characteristics !== "object") {
          this.settingsData.var_characteristics = {};
        }
        for (const characteristics of this.characteristics) {
          if (
            typeof this.settingsData.characteristics[characteristics.id] !==
            "object"
          ) {
            this.settingsData.characteristics[characteristics.id] = [];
          }
        }
      }
    },
    languages() {
      if (this.language === undefined && this.languages.length > 0) {
        this.language = this.languages[0].code;
      }
    },
    values: {
      deep: true,
      handler() {
        this.valuesData = Object.assign({}, this.values);
      },
    },
    show() {
      if (this.show) {
        for (const section of this.elements) {
          if (section?.translate) {
            if (typeof this.settingsData[section.key] !== "object") {
              this.settingsData[section.key] = {};
            }
          }
        }
        this.productSelector = "";
        this.showData = true;
        this.myModal.show();
        this.translatable = false;
        setTimeout(() => {
          this.productList = [{ id: null, products: [] }];
          if (this.selectedBlock?.value?.products) {
            for (const product of this.selectedBlock.value.products) {
              this.productList.push({
                id: product.variant_id,
                products: [product],
              });
            }
          }
          for (const section of this.elements) {
            if (section?.translate) {
              if (typeof this.settingsData[section.key] !== "object") {
                this.settingsData[section.key] = {};
              }
            }
            if (
              section?.type === "featured-products" ||
              section?.type === "link"
            ) {
              if (this.links.length < 1) {
                http
                  .fetch("/products/categories/products/" + this.language)
                  .then((data) => {
                    this.addCategories(data["data"]);
                  });
                http
                  .fetch(
                    "/products/products/characteristics?block_editor=1&language=" +
                      (this.language ?? "en")
                  )
                  .then((data) => {
                    for (const characteristic of data) {
                      this.editorMode[characteristic.id] = "select";
                      if(this.settingsData?.var_characteristics?.[characteristic.id]?.length > 0){
                        this.editorMode[characteristic.id] = "variables";
                      }
                    }
                    this.characteristics = data;
                  });
                http.fetch("/page").then((data) => {
                  for (const item of data.data) {
                    item.target_page_id = item.id;
                    delete item.id;
                    this.links.push(item);
                  }
                });
              }
            } else if (section?.type === "rich-text") {
              this.loadQuill(section);
              this.translatable = true;
            } else if (section?.type === "text") {
              this.translatable = true;
            }
          }
        }, 200);
      } else {
        this.showData = false;
        this.myModal.hide();
      }
    },
    language(value, old) {
      for (const section of this.elements) {
        if (section?.type === "rich-text") {
          if (section?.translate) {
            this.settingsData[section.key][old] =
              this.quill[section.key].root.innerHTML;
          }
        }
      }
      this.refresh = true;
      setTimeout(() => {
        this.refresh = false;
        setTimeout(() => {
          for (const section of this.elements) {
            if (section?.type === "rich-text") {
              this.loadQuill(section);
            }
          }
        }, 200);
      }, 200);
    },
  },
  methods: {
    getValue(section) {
      if (section.translate) {
        if (typeof this.settingsData[section.key] !== "object") {
          this.settingsData[section.key] = {};
        }
        return this.settingsData[section.key][this.language];
      }
      return this.settingsData[section.key];
    },
    setValue(section, newValue) {
      if (section.translate) {
        this.settingsData[section.key][this.language] = newValue;
      } else {
        this.settingsData[section.key] = newValue;
      }
    },
    sortedAndFilteredValues(ch) {
      const term = (this.searchTerms[ch.id] || "")
        .toString()
        .toLowerCase()
        .trim();
      const selected = new Set(this.settingsData.characteristics[ch.id] || []);
      let values = (ch.characteristics_values || []).filter((val) => {
        if (!term) return true;
        return String(val.value).toLowerCase().includes(term);
      });
      const selectedItems = values.filter((v) => selected.has(v.id));
      const unselected = values.filter((v) => !selected.has(v.id));
      return [...selectedItems, ...unselected];
    },
    isSelected(chId, valId) {
      return (this.settingsData.characteristics[chId] || []).includes(valId);
    },
    isTagSelected(tagId) {
      return (this.settingsData.tags || []).includes(tagId);
    },
    highlightMatch(text, term) {
      if (!term) return this.escapeHtml(text);
      const regex = new RegExp(`(${this.escapeRegex(term)})`, "ig");
      return this.escapeHtml(text).replace(
        regex,
        '<mark class="bg-warning text-dark rounded px-1">$1</mark>'
      );
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    escapeHtml(unsafe) {
      return String(unsafe)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    loadQuill(item) {
      // eslint-disable-next-line no-undef
      this.quill[item.key] = new Quill(this.$refs["edit-text-" + item.key][0], {
        theme: "snow",
        formats: [
          "bold",
          "color",
          "code",
          "italic",
          "link",
          "strike",
          "script",
          "blockquote",
          "header",
          "indent",
          "list",
          "align",
          "video",
        ],
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }, { header: 1 }, { header: 2 }], // custom button values
            ["bold", "italic", "strike"],
            ["link", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ align: "" }, { align: "center" }, { align: "right" }],
            ["video", "image"],
            ["clean"],
          ],
        },
      });
    },
    addCategories(categories) {
      for (const item of categories) {
        item.featured_category = item.id;
        delete item.id;
        this.links.push(item);
        this.categories.push(item);
        if (item.categories !== undefined) {
          this.addCategories(item.categories);
        }
      }
    },
    getImageLinks(option) {
      console.log(option);
      if (option.remote) {
        return {
          src: option.path,
        };
      }

      let types = {
        0: { name: "PRODUCT", sizes: [262, 582, 720, 1440] },
        2: {
          name: "CATEGORY",
          sizes: [360, 480, 540, 768, 960, 1280, 1440, 1600],
        },
        3: {
          name: "COVER",
          sizes: [360, 480, 537, 540, 768, 960, 1280, 1440, 1600],
        },
        4: { name: "COLOR", sizes: [32, 64, 128] },
        5: { name: "MENU", sizes: [32, 64, 128, 262, 360] },
      };

      let sizes = null;
      if (types[option.type] !== undefined) {
        sizes = {};
        for (const size of types[option.type].sizes) {
          sizes[size] =
            this.mediaServer +
            "/" +
            option.path +
            "/" +
            size +
            "-" +
            option.name +
            ".webp";
          // option.format;
        }
      }

      return {
        id: option.id,
        src: this.mediaServer + "/" + option.path + "/" + option.name + ".webp",
        format: option.format,
        sizes: sizes,
      };
    },
    getLink(c) {
      if (typeof c === "string") {
        return c;
      }
      if (c.variant_id !== undefined) {
        return "/product/" + c.id + "-" + c.slug + "/" + c.variant_id;
      }
      if (c.target_url !== undefined) {
        return c.target_url;
      }
      if (c.featured_category !== undefined) {
        return "/category/" + c.featured_category + "-" + c.slug;
      }
      if (c.target_page_id !== undefined) {
        return "/" + c.slug;
      }
    },
    changeProducts(variant_id) {
      let hasNull = false;
      let count = 0;
      for (const p in this.productList) {
        if (this.productList[p].id === null) {
          if (p !== 0) {
            this.productList.splice(p, 1);
          } else {
            hasNull = true;
          }
        } else if (this.productList[p].id === variant_id) {
          count++;
          if (count > 1) {
            this.productList.splice(p, 1);
          }
        }
      }
      if (!hasNull) {
        this.productList.unshift({ id: null, products: [] });
      }
    },
    onLinkSearch(search, k) {
      this.linkSearch = search;
      this.fetchProducts(search, k, this.linkProducts);
    },
    fetchProducts(search, loading, p) {
      if (search.length < 3) {
        return;
      }
      this.q = search;
      loading(true);
      http
        .fetch(
          this.productSelector === "bundle"
            ? "/bundles/search"
            : "/products/products/search",
          {
            q: search,
            all: 1,
          }
        )
        .then((data) => {
          p.products = data;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    },
    fetchImages(search, loading, name) {
      if (search.length < 3) {
        return;
      }
      loading(true);
      http
        .fetch("/images/search", {
          q: search,
        })
        .then((data) => {
          this.images[name] = data;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    },
    browseImages(name, imageType = 3) {
      http.fetch("/images?type=" + imageType).then((data) => {
        this.images[name] = data;
      });
    },
    deleteImage(sectionKey, imgId) {
      this.images[sectionKey] = this.images[sectionKey].filter(
        (img) => img.id !== imgId
      );
      http
        .fetch("/images/delete", {
          image: imgId,
        })
        .then((data) => {
          if (data.need_delete) {
            const request = new XMLHttpRequest();
            const formData = new FormData();
            formData.append("token", data.token);
            formData.append("path", data.image.path);

            request.open(
              "POST",
              process.env.VUE_APP_MEDIA_API + "/images/delete"
            );

            request.send(formData);
          }
        });
    },
    save() {
      let block = this.selectedBlock;
      for (const section of this.elements) {
        if (section?.type === "featured-products") {
          if (
            this.productSelector === "product" ||
            this.productSelector === "bundle"
          ) {
            delete this.settingsData.featured_category;
            delete this.settingsData.characteristics;
            delete this.settingsData.tags;
            this.settingsData.featured_products = [];
            this.settingsData.featured_bundles = [];
            block.value.products = [];
            for (const productItem of this.productList) {
              if (productItem.id === null || productItem.id === undefined) {
                continue;
              }
              let product = productItem.products.find(
                (e) => e.variant_id === productItem.id
              );
              console.log(productItem);
              console.log(product);
              if (product.type === "BUNDLE") {
                this.settingsData.featured_bundles.push(productItem.id);
              } else {
                this.settingsData.featured_products.push(productItem.id);
              }
              block.value.products.push(product);
            }
          } else {
            this.settingsData.featured_products = [];
            delete this.settingsData.featured_products;
            this.settingsData.featured_bundles = [];
            delete this.settingsData.featured_bundles;
            block.value.products = [];
          }
        } else if (section.type === "rich-text") {
          if (section?.translate) {
            this.settingsData[section.key][this.language] =
              this.quill[section.key].root.innerHTML;
          } else {
            this.settingsData[section.key] =
              this.quill[section.key].root.innerHTML;
          }
        }
      }

      this.$emit("update:block", this.selectedBlock);
      //   this.$emit("update:settings", this.settingsData);
      this.$emit("save", this.settingsData);
      this.$emit("update:show", false);
    },
    startUpload(id) {
      document.getElementById("file_" + id).click();
      // this.$refs["file_" + i].click();
    },
    btoa(str) {
      return window.btoa(str);
    },
    upload(key, type) {
      //  let file = this.$refs["file" + window.btoa(name+item+i)].files[0];
      let file = document.getElementById("file_" + window.btoa(key)).files[0];

      const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

      if (file.size > maxSize) {
        alert("File is too large. Maximum size is 20 MB.");
        document.getElementById("file_" + window.btoa(key)).value = ""; // reset file input
        return;
      }

      const request = new XMLHttpRequest();
      this.uploadPercent = 0;
      this.uploadProccess = true;
      const id = Math.round(new Date() / 1000);
      const fileName = file.name.replace(/ /g, "-");
      let send = { type: type, id: id, images: [fileName] };

      const _this = this;
      http.fetch("/files/upload", send).then((data) => {
        const formData = new FormData();
        formData.append("image", file, fileName);
        formData.append("token", data.token);
        formData.append("album", id);
        formData.append("category", type);

        request.open("POST", process.env.VUE_APP_MEDIA_API + "/images/upload");

        request.upload.onprogress = function (evt) {
          let e = Math.ceil((evt.loaded / file.size) * 60);
          _this.uploadPercent = e;
          if (e > 59) {
            let interval = setInterval(() => {
              if (_this.uploadProccess && _this.uploadPercent < 98) {
                _this.uploadPercent += 1;
              } else {
                clearInterval(interval);
              }
            }, 2000);
          }
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            let data2 = JSON.parse(request.responseText);
            _this.images[key] = data2.operation.images;
            _this.uploadPercent = 98;
            setTimeout(() => {
              _this.uploadPercent = 100;
              _this.uploadProccess = false;
              _this.settingsData[key] = _this.getImageLinks(
                data2.operation.images[0]
              );
            }, 200);
          } else {
            console.log("oh no");
            _this.uploadProccess = false;
          }
        };

        request.onerror = function () {
          _this.uploadProccess = false;
        };

        request.send(formData);
      });
    },
  },
};
</script>

<style scoped>
.hover-shadow {
  transition: box-shadow 0.2s;
}
.hover-shadow:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}
.form-check {
  cursor: pointer;
}
mark {
  background-color: #fff3bf;
}

.option-card {
  border: 2px solid #dee2e6;
  border-radius: 12px;
  transition: all 0.2s ease;
  background-color: #fff;
}
.option-card.active {
  border-color: #0d6efd;
  background-color: #e7f1ff;
  box-shadow: 0 0 10px rgba(13, 110, 253, 0.2);
}
.option-card:hover {
  border-color: #0d6efd;
  transform: translateY(-3px);
}
.option-icon svg {
  color: #0d6efd;
}

.segmented-control {
  display: inline-flex;
  align-items: center;
  gap: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 999px;
  overflow: hidden;
  background: #fff;
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
}

/* hide radio inputs but keep them focusable */
.segmented-control input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* labels act as buttons */
.segmented-control label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  font-size: 0.85rem;
  line-height: 1;
  color: #333;
  transition: background 0.15s ease, color 0.15s ease;
  user-select: none;
  min-width: 100px; /* adjust for desired size */
  text-align: center;
}

/* default (unselected) area */
.segmented-control label:not(:first-child) {
  border-left: 1px solid rgba(0, 0, 0, 0.04);
}

/* selected state using adjacent-sibling selector */
.segmented-control input[type="radio"]:checked + label {
  background: linear-gradient(
    180deg,
    #0d6efd 0%,
    #0b5ed7 100%
  ); /* bootstrap-blue-like */
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(11, 92, 215, 0.12) inset;
}

/* focus visible for keyboard users */
.segmented-control input[type="radio"]:focus + label {
  outline: 3px solid rgba(13, 110, 253, 0.18);
  outline-offset: 2px;
  z-index: 1;
}

/* small modifier to fit tight spaces */
.segmented-control--sm label {
  padding: 4px 8px;
  font-size: 0.8rem;
  min-width: 88px;
}

/* responsive: collapse to stacked small buttons on tiny screens */
@media (max-width: 420px) {
  .segmented-control {
    flex-direction: column;
    border-radius: 8px;
  }
  .segmented-control label {
    min-width: 100%;
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
  .segmented-control label:first-child {
    border-top: none;
  }
}
</style>
